// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import 'swiper/dist/css/swiper.css';
import 'babel-polyfill'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import {IsPC} from '../static/js/tool'
import el from "element-ui/src/locale/lang/el";

Vue.use(Vant);
Vue.use(ElementUI);
Vue.config.productionTip = false
const IE11RouterFix = {
  methods: {
    hashChangeHandler: function() { this.$router.push(window.location.hash.substring(1, window.location.hash.length)); },
    isIE11: function() { return !!window.MSInputMethodContext && !!document.documentMode; }
  },
  mounted: function() { if ( this.isIE11() ) { window.addEventListener('hashchange', this.hashChangeHandler); } },
  destroyed: function() { if ( this.isIE11() ) { window.removeEventListener('hashchange', this.hashChangeHandler); } }
};
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  mounted() {
    this.getIsPc()
  },
  methods: {
    getIsPc() {
      if (!IsPC()) {
        this.$router.push('/mobile')
      }
      console.log(IsPC())
    }
  },
  components: { App },
  template: '<App/>',
  mixins: [IE11RouterFix],
})



// WEBPACK FOOTER //
// ./src/main.js